<div [formGroup]="formGroup">
    <label for="typeahead-http" class="form-control-label">
        {{ label }}
        <span class="text-danger">{{ isRequired ? '*' : '' }}</span>
    </label>
    <input
        id="typeahead-http"
        type="text"
        class="form-control"
        [class.is-invalid]="searchFailed"
        [ngbTypeahead]="search"
        [formControlName]="controlName"
        [resultFormatter]="formatter"
        [inputFormatter]="formatter"
        (selectItem)="onSelect($event)" />
    <div class="invalid-feedback">Campo inválido</div>
</div>
